import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import styles from './Settings.module.scss';
import { useToastError } from '~/utils/useToastError';
import { instance } from '~/utils/api/api';
import { ButtonWithChildren } from '~/ui/ButtonWithChildren/ButtonWithChildren';
import SpinnerCircle from '~/ui/SpinnerCircle/SpinnerCircle';
import { useToastSuccess } from '~/utils/useToastSuccess';
import CustomSelect from '~/components/Shared/CustomSelect/CustomSelect';
import { languageData } from '~/utils/language/languageData';
import { versionData } from '~/utils/versionData';
import i18next from 'i18next';
import NotificationSettings from '~/components/Shared/NotificationSettings/NotificationSettings';

const Settings = (): JSX.Element => {
  const { t, i18n } = useTranslation();
  const toastError = useToastError();
  const toastSuccess = useToastSuccess();

  const laguage = languageData();

  const getCurrentLanguageId = () => {
    return laguage.find(item => item.type === i18n.language);
  };

  const initialValues = {
    language: getCurrentLanguageId(),
  };

  const formik = useFormik({
    initialValues,

    onSubmit: async values => {
      try {
        await instance.post('admin/settings', {
          language_id: values.language?.id,
        });
        toastSuccess(t('settings_updated'));
      } catch (error) {
        toastError(error);
      } finally {
        i18n.changeLanguage(values.language?.type);
        localStorage.setItem('preferLanguage', values?.language?.type || '');
        formik.resetForm({
          values: { language: getCurrentLanguageId() },
        });
      }
    },
  });

  return (
    <Page heading={<Heading text={t('settings')} />}>
      <div className={styles.formContainer}>
        <form onSubmit={formik.handleSubmit} className={styles.form}>
          <CustomSelect
            label={t('language')}
            value={laguage.find(
              language => language.id === formik.values.language?.id
            )}
            onChange={value => {
              formik.setFieldValue('language', value);
            }}
            placeholder={t('validate_language')}
            options={laguage}
          />
          <ButtonWithChildren type="submit" className={styles.formBtn}>
            {formik.isSubmitting ? <SpinnerCircle /> : t('save_n_exit')}
          </ButtonWithChildren>
        </form>
      </div>
      <NotificationSettings />
      <span className="version">
        {i18next.t('version')} {versionData.version}
      </span>
    </Page>
  );
};

export default Settings;
